export default "__VITE_ASSET__627e3138__"